import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";


const firebaseConfig = {
    apiKey: "AIzaSyBPaqLmZemZI5gxz11hLR-DfNidhWmGpf0",
    authDomain: "wishallnoteapp.firebaseapp.com",
    databaseURL: "https://wishallnoteapp.firebaseio.com",
    projectId: "wishallnoteapp",
    storageBucket: "wishallnoteapp.appspot.com",
    messagingSenderId: "753309047288",
    appId: "1:753309047288:web:2be417607493000ad81e0d",
    measurementId: "G-WE3SZ2X8CV"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const realtimeDB = getDatabase(app);